import { POCKET_ADD, POCKET_PENDING, POCKET_REMOVE, SET_POCKET } from '../types'

export const POCKET_LIMIT = 5

export interface PocketWord {
  word: string
  languageDictionaryId: string | null
  pinyin: string
  meaning: string
  hasAudio: boolean
  sentenceWords: string[]
  sentenceEn: string
  storyId: string
  createdAt?: string
}

export interface PocketState {
  words: PocketWord[]
  loaded: boolean
  // Words on their way into the pocket: they count towards the limit and show as pocketed in the panel.
  pending: string[]
}

const initialState: PocketState = { words: [], loaded: false, pending: [] }

export default function pocketReducer(state: PocketState = initialState, action: any): PocketState {
  switch (action.type) {
    case SET_POCKET:
      return { ...state, words: action.payload, loaded: true }
    case POCKET_ADD:
      if (state.words.some((w) => w.word === action.payload.word)) return state
      return { ...state, words: [...state.words, action.payload] }
    case POCKET_REMOVE:
      return { ...state, words: state.words.filter((w) => w.word !== action.payload) }
    case POCKET_PENDING:
      return {
        ...state,
        pending: action.payload.on
          ? [...state.pending.filter((w) => w !== action.payload.word), action.payload.word]
          : state.pending.filter((w) => w !== action.payload.word),
      }
    default:
      return state
  }
}
